import i18n from '@/i18n'
import { VALIDATE_NUMBER } from '@/constants/regex/validate'
import formatNumberFullSize from '@utils/format-number-full-size'
export default [
  {
    title: 'apiKey',
    value: '',
    default: '',
    validate: [
      (v) => (!!v && !!v.trim()) || i18n.t('requireField'),
      (v) => v.length <= 100 || i18n.t('requireField'),
    ],
    require: true,
    key: 'api_key',
  },
  {
    title: 'groupMembership',
    value: null,
    default: null,
    validate: [],
    data: [
      {
        value: null,
        text: 'グループを割り当てない',
      },
    ],
    require: true,
    key: 'group_user_no',
  },
  {
    title: 'operationReservation',
    value: 1,
    default: 1,
    validate: [],
    require: true,
    data: [
      {
        value: 1,
        text: '予約時間で入室申請を作成、承認済みにする',
      },
      {
        value: 2,
        text: '予約時間で入室申請を作成',
      },
      {
        value: 3,
        text: '予約時間を有効期間とするユーザ登録する',
      },
      {
        value: 4,
        text: 'ユーザ登録する。有効期間は指定しない（常に有効）',
      },
    ],
    key: 'reserve_action',
  },
  {
    title: 'behaviorCompletion',
    value: 2,
    default: 2,
    validate: [],
    require: true,
    data: [
      {
        value: 1,
        text: 'ユーザを削除する',
      },
      {
        value: 2,
        text: '何もしない',
      },
    ],
    key: 'complete_action',
  },
  {
    title: 'deleteDays',
    value: 1,
    default: 1,
    validate: [],
    require: true,
    data: [
      {
        value: 1,
        text: '1日後',
      },
      {
        value: 3,
        text: '3日後',
      },
      {
        value: 7,
        text: '7日後',
      },
      {
        value: 30,
        text: '30日後',
      },
      {
        value: 90,
        text: '90日後',
      },
    ],
    child: true,
    key: 'delete_days',
  },
  {
    title: 'behaviorCanceling',
    value: 1,
    default: 1,
    validate: [],
    require: true,
    data: [
      {
        value: 1,
        text: '入室申請を取り消す',
      },
      {
        value: 2,
        text: 'ユーザを無効に設定する',
      },
      {
        value: 3,
        text: '何もしない',
      },
    ],
    key: 'cancel_action',
  },
  {
    title: 'qrCodeInterval',
    value: 1,
    default: 1,
    validate: [],
    require: true,
    data: [
      {
        value: 0,
        text: '使用しない',
      },
      {
        value: 1,
        text: '固定',
      },
      {
        value: 2,
        text: '予約毎に変更',
      },
      {
        value: 3,
        text: '1分毎に変更（OTP）',
      },
      {
        value: 4,
        text: '1分毎に変更（OTP）、表示端末を限定する',
      },
    ],
    key: 'qr_interval',
  },
  {
    title: 'numericKeypadInterval',
    value: 0,
    default: 0,
    validate: [],
    require: true,
    data: [
      {
        value: 0,
        text: '使用しない',
      },
      {
        value: 1,
        text: '固定',
      },
      {
        value: 2,
        text: '予約毎に変更',
      },
      {
        value: 3,
        text: '1分毎に変更（OTP）',
      },
      {
        value: 4,
        text: '1分毎に変更（OTP）、表示端末を限定する',
      },
    ],
    key: 'tenkey_interval',
  },
  {
    title: 'margin',
    value: 0,
    default: 0,
    validate: [
      (v) => VALIDATE_NUMBER.test(v) || i18n.t('errorMaxLength1440'),
      (v) =>
        v <= 1440 ||
        formatNumberFullSize(v) <= 1440 ||
        i18n.t('errorMaxLength1440'),
    ],
    require: true,
    key: 'margin',
  },
  {
    title: 'minimumID',
    value: 1000,
    default: 1000,
    validate: [
      (v) => VALIDATE_NUMBER.test(v) || i18n.t('errorMinimumUserId'),
      (v) => v >= 1 || i18n.t('errorMinimumUserId'),
      (v) =>
        v <= 999999 ||
        formatNumberFullSize(v) <= 999999 ||
        i18n.t('errorMinimumUserId'),
    ],
    require: true,
    key: 'min_user_id',
  },
  {
    title: 'titleEmail',
    value: '',
    default: '',
    validate: [
      (v) => (!!v && !!v.trim()) || i18n.t('requireField'),
      (v) => v.length <= 250 || i18n.t('errorMaxLength250'),
    ],
    require: true,
    key: 'email_title',
  },
  {
    title: 'contentEmail',
    value: '',
    default: '',
    validate: [
      (v) => (!!v && !!v.trim()) || i18n.t('requireField'),
      (v) => v.length <= 4500 || i18n.t('errorMaxLength4500'),
    ],
    require: true,
    key: 'email_template',
  },
  {
    title: 'bccEmail',
    value: '',
    default: 'false',
    validate: [],
    require: true,
    key: 'email_use_bcc',
  },
  {
    title: 'bccAddressEmail',
    value: '',
    default: '',
    validate: [(v) => v.length <= 50 || i18n.t('errorMaxLength50')],
    require: false,
    child: true,
    key: 'email_bcc',
  },
  {
    title: 'settingEmail',
    value: '',
    default: '',
    validate: [],
    require: true,
    key: 'email_use_user_mail',
  },
  {
    title: 'serverEmail',
    value: '',
    default: '',
    validate: [
      (v) => (!!v && !!v.trim()) || i18n.t('errorMaxLength50'),
      (v) => v.length <= 50 || i18n.t('errorMaxLength50'),
    ],
    require: true,
    child: true,
    key: 'email_host',
  },
  {
    title: 'portEmail',
    value: '',
    default: '',
    validate: [
      (v) => VALIDATE_NUMBER.test(v) || i18n.t('errorMaxLength65535'),
      (v) =>
        v <= 65535 ||
        formatNumberFullSize(v) <= 65535 ||
        i18n.t('errorMaxLength65535'),
    ],
    require: true,
    child: true,
    key: 'email_port',
  },
  {
    title: 'sslEmail',
    value: '',
    default: 'false',
    validate: [],
    require: true,
    child: true,
    key: 'email_use_ssl',
  },
  {
    title: 'accountEmail',
    value: '',
    default: '',
    validate: [
      (v) => (!!v && !!v.trim()) || i18n.t('errorMaxLength50'),
      (v) => v.length <= 50 || i18n.t('errorMaxLength50'),
    ],
    require: true,
    child: true,
    key: 'email_user',
  },
  {
    title: 'fromEmail',
    value: '',
    default: '',
    validate: [
      (v) => (!!v && !!v.trim()) || i18n.t('errorMaxLength50'),
      (v) => v.length <= 50 || i18n.t('errorMaxLength50'),
    ],
    require: true,
    child: true,
    key: 'email_from',
  },
  {
    title: 'passwordEmail',
    value: '',
    default: '',
    validate: [
      (v) => (!!v && !!v.trim()) || i18n.t('errorMaxLength50'),
      (v) => v.length <= 50 || i18n.t('errorMaxLength50'),
    ],
    require: true,
    child: true,
    key: 'email_pass',
  },
]
